// The question data the BPM block plots, ported from the coffee block (calcProcessedData) and
// its Lib.calcModelData. Texts are processed for the report's logic / alias visibility, and the
// quadrant axis pickers are built from the processed batches.

import { cloneQuestionAndProcessTexts } from '@aytm/app/stats/lib/stat-page'
import { noTextPlaceholder, removeLogicFromText } from '@aytm/app/stats/page/components/lib/utils'

const LOGIC_TEXT = /\[(Hide|Show) if/gim

// A question whose texts carry display logic shows how many respondents each item was put to.
export const calcShowResponses = ({ questionVariants = [], batches = [] } = {}) =>
  [...questionVariants, ...batches].some(item => {
    LOGIC_TEXT.lastIndex = 0
    return LOGIC_TEXT.test(item?.text || '')
  })

const optionOf = item => {
  const text = removeLogicFromText(item.text || '') || noTextPlaceholder(item)

  return { text, value: `${item.position}`, listText: text }
}

export const calcChartSelectOptions = (batches = []) => batches.map(optionOf)

export const calcChartSelectOptionsWithNone = (batches = []) => [
  { text: 'None', value: 'none', listText: 'None' },
  ...calcChartSelectOptions(batches)
]

// `preprocessed` marks the info-view path, which hands the block texts that were already
// processed by the wrapper. The visibility settings arrive as arguments rather than being read
// here, so a change to either re-derives the data.
export const calcProcessedData = ({
  questionVariants = [],
  batches = [],
  preprocessed = false,
  qLogicVisibility,
  qAliasesVisibility
} = {}) => {
  const showResponses = calcShowResponses({ questionVariants, batches })

  if (preprocessed || 'hide' !== qLogicVisibility) {
    return { questionVariants, batches, showResponses }
  }

  const processed = cloneQuestionAndProcessTexts(
    { questionVariants, batches },
    { removeLogic: true, removeAliases: 'hide' === qAliasesVisibility }
  )

  return {
    questionVariants: processed?.questionVariants || questionVariants,
    batches: processed?.batches || batches,
    showResponses
  }
}

export const MODE_TYPES = { bpm: ['m', 't', 'q'], qa: ['q'] }

// The info-view path passes a fixed single-mode list; the question path derives it from the type.
export const calcModes = ({ modes, type } = {}) => modes || MODE_TYPES[type] || MODE_TYPES.bpm

export const calcDefaultMode = ({ defaultMode, modes, type } = {}) => defaultMode || calcModes({ modes, type })[0]
